import { RouteComponentProps } from '@reach/router'
import * as React from 'react'
import styled from 'styled-components'
import { IntroText, Spacer } from '../../../../common/src/components/core'
import emojis from '../../../../common/src/emojis'
import { FetchUserContextQuery } from '../../../../common/src/types.gen'
import ClockInClockOut from './ClockInClockOut'
import OperatorDashboardSection from './OperatorDashboardSection'

const RNG = Math.random()

const LobbyWrap = styled.div`
  box-sizing: border-box;
  min-width: 1152px;
  width: 1152px;
  margin: 0 auto;
  padding: 32px;
  height: 100%;
`

const ClockInRowContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
`

interface LobbyPageProps extends RouteComponentProps {
  user: FetchUserContextQuery['self']
}

export default class LobbyPage extends React.PureComponent<LobbyPageProps> {
  render() {
    const { user } = this.props
    const firstName = user.name.split(' ')[0]
    const emoji = emojis[(RNG * emojis.length) | 0]

    return (
      <LobbyWrap>
        <IntroText>
          Welcome, {firstName}!<Spacer width={16} />
          {emoji}
        </IntroText>
        <Spacer height={8} />
        <ClockInRowContainer>
          <ClockInClockOut user={user} />
        </ClockInRowContainer>
        <Spacer height={16} />
        <OperatorDashboardSection user={user} />
      </LobbyWrap>
    )
  }
}
